import { Component, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { concat, Observable, of, Subject } from 'rxjs';
import { MiscService, VisitorService, VisitorFollowUpService } from '@services/index';
import { Globals } from '@app/app.globals';

@Component({
    selector: 'app-util-visitor-parts-follow-up-modals-add',
    templateUrl: './add.component.html',
})
export class UtilVisitorPartsFollowUpModalsAddComponent implements OnInit {
    @Output() addFollowUpEvent = new EventEmitter<any>();

    isLoading = false;
    isSubmitting = false;
    modal = "#addFollowUpModal";
    cud = "add";
    pickerConfig: any;
    visitorFollowUp: any;
    visitorId: number;
    visitors: Observable<any[]>;
    visitorsLoading = false;
    visitorsInput = new Subject();
    addForm = this.fb.group({
        id: null,
        visitor_id: [null, Validators.required],
        date: [null, Validators.required],
        worker: [null, Validators.required],
        informations: [null, Validators.required]
    });
    hasData = {
        visitorFollowUp: false
    };

    @ViewChild('datePicker') datePicker;

    constructor(private cdref: ChangeDetectorRef,
                private fb: UntypedFormBuilder,
                private miscService: MiscService,
                private visitorService: VisitorService,
                private visitorFollowUpService: VisitorFollowUpService,
                public globals: Globals) {
        this.miscService.setPageTitle("TITLES.VISITOR_FOLLOW_UPS");
    }

    ngOnInit() {
        this.pickerConfig = JSON.parse(JSON.stringify(this.globals.pickerConfig));
        this.cdref.detectChanges();
    }

    reset() {
        this.addForm.reset();
        this.resetDate();
        this.visitorId = null;
        this.cud = "add";
    }
    
    openModal(visitorId = null, visitorFollowUp = null) {
        if(this.miscService.can("cudVisitorFollowUp")) {
            this.isLoading = true;
            this.visitorFollowUp = visitorFollowUp;
            this.hasData.visitorFollowUp = this.miscService.checkDataLength(this.visitorFollowUp);
            this.reset();
            this.visitorId = visitorId;
            if(this.visitorId) {
                this.addForm.get('visitor_id').patchValue(visitorId);
            }
            else {
                this.loadVisitors();
            }
            if(this.hasData.visitorFollowUp) {
                this.cud = "edit";
                this.addForm.patchValue(this.visitorFollowUp);
                if(this.visitorFollowUp.date) {
                    this.datePicker.setDate(this.visitorFollowUp.date);
                }
            }
            this.isLoading = false;
            $(this.modal).modal('show');
        }
    }

    goToAddVisitorUrl() {
        $(this.modal).modal('hide');
        this.miscService.goToUrlDelay(['/visitor/add']);
    }

    loadVisitors() {
        this.visitors = concat(
            of([]),
            this.visitorsInput.pipe(
                distinctUntilChanged(),
                tap(() => this.visitorsLoading = true),
                debounceTime(500),
                switchMap(term => this.visitorService.getAll({term: term, limit: 5, filter: true}).pipe(
                    catchError(() => of([])),
                    tap(() => this.visitorsLoading = false),
                ))
            )
        );
    }

    dateChanged(evt, field) {
        if(evt) {
            let date = evt;
            this.addForm.get(field).patchValue(date);
        }
        else {
            this.resetField(field);
        }
	}

    resetDate() {
        this.datePicker.resetDateNow();
    }

    resetField(field) {
        this.addForm.get(field).reset();
    }

    submit() {
        this.isSubmitting = true;
        let data = this.addForm.value;
        if(this.cud == "add") {
            this.create(data);
        }
        else {
            this.update(data);
        }
    }

    create(data) {
        this.visitorFollowUpService.create(data).subscribe(data => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_FOLLOW_UP_CREATED", status: 'success' });
            $(this.modal).modal('hide');
            this.addFollowUpEvent.emit();
        }, error => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_FOLLOW_UP_NOT_CREATED" });
        });
    }

    update(data) {
        this.visitorFollowUpService.update(data).subscribe(data => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_FOLLOW_UP_UPDATED", status: 'success' });
            $(this.modal).modal('hide');
            this.addFollowUpEvent.emit();
        }, error => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_FOLLOW_UP_NOT_UPDATED" });
        });
    }
}
